import React, { useEffect, useState } from "react";
import { Layout, Alert, Form, Row, Col, notification, Switch } from "antd";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

/* CUSTOM COMPONENT */
import LoginHeader from "../../component/LoginHeader/LoginHeader";
import {
  SiteLayoutBackground,
  Left,
  Right,
  LoginBox,
  XContent,
  SignIn,
  TextBox,
  XButton,
  FormItem,
  SignUpDiv,
  SignUpLink,
  SocialButton,
} from "./SignUpStyle";

/* Actions */
import { saveDoctor, saveDoctorReset } from "../../action/saveDoctorAction";
import { FaceBookIcon, GoogleIcon } from "../../component/CustomIcons";
import { BlankSpace } from "../../component/Xcomponent";

const { Footer } = Layout;

const SignUp = (props) => {
  /* variable & state */
  const { saveDoctor, saveDoctorState, saveDoctorReset } = props;

  const [formData, setFormData] = useState({
    email: "",
    // password: "",
    // confirm_password: "",
    fname: "",
    lname: "",
    mobile_number: "",
    // video_consulatant: false,
    institute_name: "",
    institute_address: "",
    institute_email: "",
    registration_number: null,
    fmf_code: null,
  });
  const [redirect, setRedirect] = useState(false);

  /* Callback */
  useEffect(() => {
    return () => {
      saveDoctorReset();
    };
  }, []);
  useEffect(() => {
    if (saveDoctorState.apiState === "success") {
      notification["success"]({
        message: saveDoctorState.message,
      });
      setRedirect(true);
    } else {
      saveDoctorState.apiState = "";
    }
  }, [saveDoctorState.apiState]);

  /* function */
  const handleOnChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onFormSubmit = () => {
    // Structure the data as required by the API
    const requestData = {
      doctorDetails: {
        email: formData.email,
        // password: formData.password,
        // confirm_password: formData.confirm_password,
        fname: formData.fname,
        lname: formData.lname,
        mobile_number: formData.mobile_number,
        // video_consulatant: formData.video_consulatant,
      },
      instituteDetails: {
        institute_name: formData.institute_name,
        institute_address: formData.institute_address,
        institute_email: formData.institute_email,
        registration_number: formData.registration_number,
        fmf_code: formData.fmf_code,
      },
    };

    // Now you can send the request to your API
    saveDoctor(requestData);
    // saveDoctor(formData);
  };

  return (
    <>
      {redirect && <Redirect to="/" />}
      <Layout style={{ backgroundColor: "#fff" }}>
        {/* <LoginHeader /> */}
        <XContent
          className="site-layout"
          style={{ padding: "0 50px", marginTop: 120 }}
        >
          <SiteLayoutBackground>
            <Left>
              <img
                height="100%"
                width="100%"
                src={process.env.PUBLIC_URL + "/images/svg/DoctorLogin.svg"}
                alt=""
              />
            </Left>
            <Right>
              <LoginBox>
                <SignIn>Sign up</SignIn>
                {saveDoctorState.apiState === "error" && (
                  <Alert
                    style={{ marginBottom: 8 }}
                    message={saveDoctorState.message}
                    type="error"
                    showIcon
                  />
                )}
                <Form layout="vertical" onFinish={onFormSubmit}>
                  <Row gutter={[20, 20]}>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem
                        label="First Name"
                        name="fname"
                        rules={[{ required: true, message: "Required" }]}
                      >
                        <TextBox
                          name="fname"
                          onChange={handleOnChange}
                          size="large"
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem
                        label="Last Name"
                        name="lname"
                        rules={[{ required: true, message: "Required" }]}
                      >
                        <TextBox
                          name="lname"
                          onChange={handleOnChange}
                          size="large"
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem
                        label="Mobile Number"
                        name="mobile_number"
                        rules={[{ required: true, message: "Required" }]}
                      >
                        <TextBox
                          name="mobile_number"
                          onChange={handleOnChange}
                          size="large"
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem
                        label="Email ID"
                        name="email"
                        rules={[
                          { required: true, message: "Required" },
                          { type: "email", message: "Email id is not valid" },
                        ]}
                      >
                        <TextBox
                          name="email"
                          onChange={handleOnChange}
                          size="large"
                        />
                      </FormItem>
                    </Col>

                    {/* <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem
                        label="Password"
                        name="password"
                        rules={[
                          { required: true, message: "Required" },
                          {
                            pattern: "^(?=.{8,})",
                            message:
                              "Password should be at least 8 characters long",
                          },
                        ]}
                      >
                        <TextBox.Password
                          name="password"
                          onChange={handleOnChange}
                          size="large"
                        />
                      </FormItem>
                    </Col> */}
                    {/* <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem
                        label="Confirm Password"
                        name="confirm_password"
                        rules={[
                          {
                            required: true,
                            message: "Confirm your password",
                          },
                          ({ getFieldValue }) => ({
                            validator(rule, value) {
                              if (
                                !value ||
                                getFieldValue("password") === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject("Passwords do not match");
                            },
                          }),
                        ]}
                      >
                        <TextBox.Password
                          name="confirm_password"
                          onChange={handleOnChange}
                          size="large"
                        />
                      </FormItem>
                    </Col> */}
                    {/* requested by lilac */}
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem
                        label="Institute Name"
                        name="institute_name"
                        rules={[{ required: true, message: "Required" }]}
                      >
                        <TextBox
                          name="institute_name"
                          onChange={handleOnChange}
                          size="large"
                        />
                      </FormItem>
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem
                        label="Institute Address"
                        name="institute_address"
                        rules={[{ required: true, message: "Required" }]}
                      >
                        <TextBox
                          name="institute_address"
                          onChange={handleOnChange}
                          size="large"
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem
                        label="Institute Email"
                        name="institute_email"
                        rules={[
                          { required: true, message: "Required" },
                          { type: "email", message: "Email is not valid" },
                        ]}
                      >
                        <TextBox
                          name="institute_email"
                          onChange={handleOnChange}
                          size="large"
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem
                        label="Registration No."
                        name="registration_number"
                        rules={[{ required: true, message: "Required" }]}
                      >
                        <TextBox
                          name="registration_number"
                          onChange={handleOnChange}
                          size="large"
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem
                        label="FMF Id"
                        name="fmf_code"
                        rules={[{ required: true, message: "Required" }]}
                      >
                        <TextBox
                          name="fmf_code"
                          onChange={handleOnChange}
                          size="large"
                        />
                      </FormItem>
                    </Col>

                    {/* requested by lilac */}

                    {/* <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem label="Whether to use video consultant">
                        <Switch
                          checkedChildren={<CheckOutlined />}
                          unCheckedChildren={<CloseOutlined />}
                          onChange={(checked) =>
                            setFormData({
                              ...formData,
                              ["video_consulatant"]: checked,
                            })
                          }
                        />
                      </FormItem>
                    </Col> */}
                  </Row>
                  <Row gutter={[20, 20]}>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <FormItem>
                        <XButton
                          htmlType="submit"
                          type="primary"
                          size="large"
                          loading={
                            saveDoctorState.apiState === "loading"
                              ? true
                              : false
                          }
                          block
                        >
                          Sign Up
                        </XButton>
                      </FormItem>
                    </Col>
                  </Row>
                  <Row gutter={[20, 20]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <FormItem>
                        <SignUpDiv>
                          <label>
                            Already have an account?
                            <SignUpLink to={"login"}>Sign In</SignUpLink>
                          </label>
                        </SignUpDiv>
                      </FormItem>
                    </Col>
                  </Row>
                  <BlankSpace />
                  <BlankSpace />
                  {/* requested by lilac */}
                  {/* <Row gutter={[20, 20]}>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <SocialButton shape="round" size="large" block>
                        <GoogleIcon /> Sign up with Google
                      </SocialButton>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                      <SocialButton shape="round" size="large" block>
                        <FaceBookIcon /> Sign up with Facebook
                      </SocialButton>
                    </Col>
                  </Row> */}
                </Form>
              </LoginBox>
            </Right>
          </SiteLayoutBackground>
        </XContent>
      </Layout>
    </>
  );
};

const mapStateToProps = (state) => ({
  saveDoctorState: state.saveDoctor,
});

const mapDispatchToProps = (dispatch) => ({
  saveDoctor: (params) => dispatch(saveDoctor(params)),
  saveDoctorReset: () => dispatch(saveDoctorReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
